import React, { FC, useMemo, useReducer } from 'react';
import { Helmet } from 'react-helmet';
import Palette from '../components/palette';
import config from '../config';
import { IconLogo } from '../icons/pacolor';

const load = () => {
   const palettes = [];
   for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i) as string;
      if (key.match(/^pacolor-#/)) {
         const value = localStorage.getItem(key);
         palettes.push(value);
      }
   }
   return palettes;
};

const reducer = (state: any[], { type, payload }: More) => {
   switch (type) {
      case 'delete':
         if (load().includes(payload)) {
            return load();
         }
         return state;
      default:
         return state;
   }
};

const PageLikes: FC<{}> = () => {
   const [state, dispatch] = useReducer(reducer, load());

   const render = useMemo(
      () => (
         <div className="content fx fx-rw fx-jcc">
            {state.map((v, i) => {
               return (
                  <Palette
                     key={i + '-palette'}
                     index={i + '-palette'}
                     style={{
                        animationDelay: i * 100 + 'ms',
                     }}
                     color={v}
                     className="fadeInUp mode-both"
                     dispatch={dispatch}
                  />
               );
            })}
         </div>
      ),
      [state],
   );

   return (
      <>
         <Helmet>
            <title>{config.SEO.likes.title}</title>
         </Helmet>
         <div className="main-content">
            <div className="container">
               <h1 style={{ textAlign: 'center' }}>My Palettes Collection</h1>

               {render}

               {state.length <= 0 && (
                  <div className="not-found-page">
                     <div className="icon logo">
                        <IconLogo />
                     </div>

                     <h3>No Likes Yet</h3>
                  </div>
               )}
            </div>
         </div>
         <style jsx>{`
            .main-content :global(.content) {
               margin-top: 30px;
               :global(.palette) {
                  margin: 5px;
                  width: calc((100% / 4) - 10px);
                  animation-duration: 0.2s;
                  @media (max-width: 992px) {
                     width: calc((100% / 3) - 10px);
                  }

                  @media (max-width: 768px) {
                     margin: 5px 2.5px;
                     width: calc((100% / 2) - 5px);
                  }
                  @media (max-width: 490px) {
                     margin: 10px 0;
                     width: 100%;
                  }
               }
            }
            .not-found-page {
               text-align: center;
               .logo {
                  max-width: 150px;
                  max-height: 150px;
                  width: 100%;
                  height: 100%;
               }
            }
         `}</style>
      </>
   );
};
export default PageLikes;
